import React from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import moment from 'moment';
import { Button, Calendar, Popover, PopoverContent, PopoverTrigger, } from '@cargomatic/ui';
/**
 * Single date picker filter.
 */
export function FilterDatePicker({ value, onChange, placeholder = 'Select date', minDate, maxDate, }) {
    const label = value ? moment(value).format('MMM D, YYYY') : placeholder;
    return (React.createElement(Popover, null,
        React.createElement(PopoverTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-start font-normal h-8 border-dashed" },
                React.createElement(CalendarIcon, { className: "size-3 mr-1.5 text-muted-foreground" }),
                React.createElement("span", { className: "text-muted-foreground text-xs" }, label))),
        React.createElement(PopoverContent, { className: "w-auto p-0 z-[1100] ag-custom-component-popup", align: "start" },
            React.createElement(Calendar, { mode: "single", selected: value, onSelect: onChange, disabled: (date) => {
                    if (minDate && date < minDate)
                        return true;
                    if (maxDate && date > maxDate)
                        return true;
                    return false;
                } }))));
}
